<!-- 直播 -->
<template>
  <div>
    <div class="modal-content" v-if="pageType == ''">
      <a-icon type="environment" theme="twoTone" class="model-site-name" />
      <span>{{ record.ws_name }}</span>
      <div class="deviseList" v-if="!this.record.DeviceList">
        <div v-for="(item, index) in ws_bind_d_ids" :key="index">
          <div @click="changed_id(item.did, index)" class="deviseList_name">
            <!-- 设备{{ item.dname ? item.dname : item.did }} -->
            设备{{ item.dimei }}
          </div>
        </div>
      </div>
    </div>
    <div class="divScreenshot">
      <canvas width="750" height="425" id="screenshot"></canvas>
    </div>
    <div
      :class="
        pageType === 'patrol'
          ? 'modal-content-nobg'
          : 'modal-content  modal-content1'
      "
    >
      <!-- :height="pageType === 'patrol' ? '750px' : '300px'" -->
      <!-- width="100%" -->
      <video
        autoplay
        controls
        :width="pageType === 'patrol' ? '100%' : '753px'"
        :height="pageType === 'patrol' ? '750px' : '425px'"
        id="myVideo"
        crossorigin="*"
        style="background: black; object-fit: cover"
        :poster="posterImg"
      ></video>

      <!-- poster="../../assets/images/imgloading.gif" -->
      <div id="local-video"></div>
      <div id="remote-video"></div>

      <div
        v-if="pageType == 'patrol' || '' || pageType == 'caseField'"
        class="opt-button"
      >
        <!-- 工地巡查页 -->
        <div class="dir-patrol">
          <a-row>
            <a-col :span="8"></a-col>
            <a-col :span="8" class="dir-btn" @click="moveCamera('up', '上')"
              ><a-icon type="up"
            /></a-col>
            <a-col :span="8"></a-col>
            <a-col :span="8" class="dir-btn" @click="moveCamera('left', '左')"
              ><a-icon type="left"
            /></a-col>
            <a-col :span="8"></a-col>
            <a-col :span="8" class="dir-btn" @click="moveCamera('right', '右')"
              ><a-icon type="right"
            /></a-col>
            <a-col :span="8"></a-col>
            <a-col :span="8" class="dir-btn" @click="moveCamera('down', '下')"
              ><a-icon type="down"
            /></a-col>
            <a-col :span="8"></a-col>
          </a-row>
        </div>
        <div class="opt-button-xuncha">
          <!-- 信号展示 -->
          <div class="xuncha_xinhao">
            <div class="xinhao opt_button1">
              <div class="xinhaoRed" v-show="NoXinhao">
                <a-icon type="close" />
              </div>
              <div id="div_sign">
                <div
                  style="
                    width: 6px;
                    height: 3px;
                    margin-top: 16px;
                    border: 1px solid #0e2d5f;
                  "
                ></div>
                <div
                  style="
                    width: 6px;
                    height: 6px;
                    margin-top: -6px;
                    margin-left: 5px;
                    border: 1px solid #0e2d5f;
                  "
                ></div>
                <div
                  style="
                    width: 6px;
                    height: 9px;
                    margin-top: -9px;
                    margin-left: 10px;
                    border: 1px solid #0e2d5f;
                  "
                ></div>
                <div
                  style="
                    width: 6px;
                    height: 12px;
                    margin-top: -12px;
                    margin-left: 15px;
                    border: 1px solid #0e2d5f;
                  "
                ></div>
                <div
                  style="
                    width: 6px;
                    height: 15px;
                    margin-top: -15px;
                    margin-left: 20px;
                    border: 1px solid #0e2d5f;
                  "
                ></div>
              </div>
            </div>
          </div>
          <!-- 播放按钮 -->
          <div
            class="v-btn"
            v-show="bofang == 1 ? true : false"
            @click="bofangPlay('bofang')"
          >
            <a-icon type="caret-right" />
          </div>
          <div
            class="v-btn"
            v-show="bofang == 2 ? true : false"
            @click="bofangPlay('zanting')"
          >
            <a-icon type="pause" />
          </div>
          <!-- 全屏按钮 -->
          <div class="v-btn" @click="quanping()">
            <a-icon type="fullscreen" />
          </div>
          <!-- 静音/取消静音按钮 -->
          <div
            class="v-btn"
            v-show="jingyin == 1 ? true : false"
            @click="handelPlay('jingyin')"
          >
            <!-- 静音 -->
            <img
              src="../../assets/images/site_img/quxiaojingyin.png"
              height="16px"
            />
          </div>
          <div
            class="v-btn"
            v-show="jingyin == 2 ? true : false"
            @click="handelPlay('quxiaojingyin')"
          >
            <!-- 取消静音 -->

            <img src="@/assets/images/site_img/jingyin.png" height="20px" />
          </div>
          <!-- 关闭麦克风 -->
          <div
            class="v-btn"
            style="background: #b82200; color: #fff"
            @click="handleCall()"
            v-if="!voiceCall"
          >
            <i class="iconfont icon-guanbimaikefeng"></i>
          </div>
          <!-- 通话中 -->
          <div
            class="v-btn"
            style="background: #2e8b57; color: #fff"
            @click="handleCall()"
            v-else
          >
            <i class="iconfont icon-maikefeng2">通话中 </i>
          </div>
          <!-- 设备重启 -->
          <div
            class="v-btn"
            @click="handleRestart()"
            v-if="
              isShowBtns.indexOf('Patrol-/api/worksite/camera/restart') > -1
            "
          >
            <a-icon type="redo" />设备重启
          </div>

          <!-- 保存预置位 -->
          <div
            class="v-btn"
            @click="returnCameraPreset()"
            v-if="isShowBtns.indexOf('Patrol-/api/worksite/camera/preset') > -1"
          >
            保存预置位
          </div>
          <!-- 返回预设位置 -->
          <div
            class="v-btn"
            @click="reset()"
            v-if="isShowBtns.indexOf('Patrol-/api/worksite/camera/reset') > -1"
          >
            <a-icon type="deployment-unit" />返回预设位置
          </div>
          <!-- 抓拍 -->
          <div class="v-btn" @click="screenshot()">
            <a-icon type="camera" />抓拍
          </div>
          <!-- 案场按钮 -->
          <div
            class="v-btn"
            v-if="
              pageTypecaseField == '2' &&
              isShowBtns.indexOf('CaseField-/api/worksite/model') > -1
            "
          >
            <div class="v-btn" @click="quxiaoSampleSiteBTN()">
              <div v-if="typecaseField == 2 && record.w_power == '1'">
                取消样板工地
              </div>
              <div v-if="typecaseField == 1 && record.w_power == '1'">
                设置样板工地
              </div>
            </div>
          </div>
          <!-- 工地巡查大屏按钮 -->
          <div
            class="v-btn-out v-btn"
            v-if="
              pageTypecaseField != '2' &&
              isShowBtns.indexOf('Patrol-/api/worksite/model') > -1
            "
          >
            <div
              class="v-btn"
              @click="setSampleSiteBTN()"
              v-if="wsModel == '2' && record.w_power == '1'"
            >
              设置为样板工地
            </div>
            <div
              class="v-btn"
              @click="setSampleSiteBTN()"
              v-if="wsModel == '1' && record.w_power == '1'"
            >
              取消样板工地
            </div>
          </div>
        </div>
      </div>
      <!--  -->
      <div class="opt-button opt_button1 opt_button2" v-else>
        <!-- 信号展示 -->
        <div class="xinhao opt_button1">
          <div class="xinhaoRed" v-show="NoXinhao">
            <a-icon type="close" />
          </div>
          <div id="div_sign">
            <div
              style="
                width: 6px;
                height: 3px;
                margin-top: 16px;
                border: 1px solid #0e2d5f;
              "
            ></div>
            <div
              style="
                width: 6px;
                height: 6px;
                margin-top: -6px;
                margin-left: 5px;
                border: 1px solid #0e2d5f;
              "
            ></div>
            <div
              style="
                width: 6px;
                height: 9px;
                margin-top: -9px;
                margin-left: 10px;
                border: 1px solid #0e2d5f;
              "
            ></div>
            <div
              style="
                width: 6px;
                height: 12px;
                margin-top: -12px;
                margin-left: 15px;
                border: 1px solid #0e2d5f;
              "
            ></div>
            <div
              style="
                width: 6px;
                height: 15px;
                margin-top: -15px;
                margin-left: 20px;
                border: 1px solid #0e2d5f;
              "
            ></div>
          </div>
        </div>
        <!-- 播放按钮 -->
        <div
          class="v-btn"
          v-show="bofang == 1 ? true : false"
          @click="bofangPlay('bofang')"
        >
          <a-icon class="iconSize" type="caret-right" />
        </div>
        <div
          class="v-btn"
          v-show="bofang == 2 ? true : false"
          @click="bofangPlay('zanting')"
        >
          <a-icon type="pause" class="iconSize" />
        </div>
        <!-- 静音/取消静音按钮 -->
        <div
          class="v-btn"
          v-show="jingyin == 1 ? true : false"
          @click="handelPlay('jingyin')"
        >
          <!-- 静音 -->
          <!-- <a-icon type="sound" /> -->
          <img
            src="../../assets/images/site_img/quxiaojingyin.png"
            height="16px"
          />
        </div>
        <div
          class="v-btn"
          v-show="jingyin == 2 ? true : false"
          @click="handelPlay('quxiaojingyin')"
        >
          <!-- 取消静音 -->

          <img src="../../assets/images/site_img/jingyin.png" height="20px" />
        </div>
        <!-- 关闭麦克风 -->
        <div
          class="v-btn"
          style="background: #b82200; color: #fff"
          @click="handleCall()"
          v-if="!voiceCall"
        >
          <i class="iconfont icon-guanbimaikefeng"></i>
        </div>
        <!-- 通话中 -->
        <div
          class="v-btn"
          style="background: #2e8b57; color: #fff"
          @click="handleCall()"
          v-else
        >
          <i class="iconfont icon-maikefeng2">通话中</i>
        </div>
        <!-- 设备重启 -->
        <div
          class="v-btn"
          @click="handleRestart()"
          v-if="
            isShowBtns.indexOf('SiteList-/api/worksite/camera/restart') > -1
          "
        >
          <a-icon type="redo" />设备重启
        </div>
        <!-- 保存预置位 -->
        <div
          class="v-btn"
          @click="returnCameraPreset()"
          v-if="isShowBtns.indexOf('SiteList-/api/worksite/camera/preset') > -1"
        >
          <!-- v-if="isShowBtns.indexOf('SiteList-/api/worksite/camera/preset') > -1" -->
          保存预置位
        </div>
        <!-- 返回预设位置 -->
        <div
          class="v-btn"
          @click="reset()"
          v-if="isShowBtns.indexOf('SiteList-/api/worksite/camera/reset') > -1"
        >
          <!-- <a-icon type="deployment-unit" /> -->
          返回预置位
        </div>

        <!-- 抓拍 -->
        <div class="v-btn" @click="screenshot()">
          <a-icon type="camera" />抓拍
        </div>
        <!-- 全屏按钮 -->
        <div class="v-btn" @click="quanping()">
          <!-- <a-icon type="fullscreen" class="iconSize" /> -->
          <img
            src="../../assets/images/site_img/fullscreen_img.png"
            alt="全屏"
            height="15px"
          />
        </div>
      </div>
      <div class="direction-button" v-if="pageType == ''">
        <a-row>
          <a-col :span="8"></a-col>
          <a-col :span="8" class="dir-btn" @click="moveCamera('up', '上')">
            <!-- <a-icon type="up"/> -->
            <a-icon type="caret-up" />
          </a-col>
          <a-col :span="8"></a-col>
          <a-col :span="8" class="dir-btn" @click="moveCamera('left', '左')">
            <!-- <a-icon type="left"/> -->
            <a-icon type="caret-left" />
          </a-col>
          <a-col :span="8"></a-col>
          <a-col :span="8" class="dir-btn" @click="moveCamera('right', '右')">
            <!-- <a-icon type="right"/> -->
            <a-icon type="caret-right" />
          </a-col>
          <a-col :span="8"></a-col>
          <a-col :span="8" class="dir-btn" @click="moveCamera('down', '下')">
            <!-- <a-icon type="down"/> -->
            <a-icon type="caret-down" />
          </a-col>
          <a-col :span="8"></a-col>
        </a-row>
      </div>
      <div class="HistoryRecord" v-if="pageType == ''">
        <div @click="SiteHistoryRecordBTN()">查看预置位历史记录</div>
        <div
          v-if="SiteList_previer_true"
          class="playback"
          @click="playbackBTN(record)"
        >
          查看回放
        </div>
        <div class="setdefault" @click="Setdefault()">设置默认设备</div>
      </div>
    </div>
    <a-modal
      :visible="visible"
      title="确认要重启此设备？"
      :confirm-loading="confirmLoading"
      @ok="restart"
      @cancel="restartCancel"
    >
      <p style="color: red">
        此步骤请谨慎操作！<br />注意：预计重启需要五分钟。
      </p>
    </a-modal>
    <a-modal
      v-if="visibleHistory"
      title="预置位历史记录"
      width="700px"
      :visible="visibleHistory"
      :confirm-loading="confirmLoadingHistory"
      @ok="handleOkHistory"
      @cancel="handleCancelHistory"
    >
      <SiteHistoryRecord :recordwsid="recordwsid"></SiteHistoryRecord>
    </a-modal>
  </div>
</template>

<script>
import {
  GetSiteVideo,
  StopSiteVideo,
  OnCall,
  OffCall,
  CameraMove,
  CameraReset,
  CameraRestart,
  CameraStatus,
  videoSignal,
  getSitPreset,
  Setdefault,
  GetWsbinddevices,
} from "@/api/video";
import { SetSampleSite } from "@/api/site";
import flvjs from "flv.js";
import LineImage from "../datav/LineImage.vue";
import SiteHistoryRecord from "../site/SiteHistoryRecord.vue";
import { urlConfig } from "@/config/config";

export default {
  components: {
    LineImage,
    SiteHistoryRecord,
  },
  name: "SitePreview", // 直播
  props: {
    record: {
      type: Object,
      default: {
        ws_name: "",
        ws_model: "",
      },
    },
    pageType: {
      type: String,
      default: "",
    },
    pageTypecaseField: {
      type: String,
      default: "",
    },
    SiteList_previer_true: {
      type: Boolean,
      default: false,
    },
  },
  ws: null,
  soundrecord: null,
  data() {
    return {
      timer: null,
      bc_id: "",
      ws_id: "",
      ws_bind_d_ids: [],
      d_id: "",
      video: {
        com_only: "",
        video_url: "",
        audio_url: "",
        stream_id: "",
        push_stream_id: "",
      },
      voiceCall: false,
      cycleMax: 15,
      cycleTime: 1,
      flvPlayer: null,
      // 弹出框
      visible: false,
      confirmLoading: false,
      wsModel: "0",
      type: "2",
      typecaseField: "2",
      ModelcaseField: "2",
      // stream_url: "webrtc://dsm.wisecommey.com:1990/stream/",
      stream_url: "webrtc://dsm.ccom.com.cn:1990/stream/",
      Video_Status: "",
      xinhao: null,
      NoXinhao: false,
      jingyin: 1,
      bofang: 2,
      signalResData2: "",
      getvideoSignalTimer: null,
      // SiteHistoryRecord: false,
      ModalText: "Content of the modal",
      visibleHistory: false,
      confirmLoadingHistory: false,
      recordwsid: "",
      // 图片地址
      pathUrl:
        urlConfig.baseUrl + "/files/picture/snapshot/snapshotpicture?filePath=",
      posterImg: "",
      isShowBtns: [],
      index1: 0,
    };
  },
  created() {
    // console.log("1111", this.SiteList_previer_true);
    // 初始化数据 触发监听  data是props

    console.log("直播", this.record);
    if (this.record.ws_id) {
      this.ws_id = this.record.ws_id;
      this.wsModel = this.record.ws_model;
      this.type = this.record.ws_model;
      if (this.record.d_id) {
        console.log("直接播放");
        this.d_id = this.record.d_id;
        this.getVideo();
      } else {
        // 如果设备号存在
        console.log(" this.ws_bind_d_ids", this.ws_bind_d_ids);
        this.GetWsbinddevices();
      }
      // this.getVideo();
    } else if (this.$route.query.ws_id) {
      this.ws_id = this.$route.query.ws_id;
      this.GetWsbinddevices();
      // this.getVideo();
    } else if (this.record.d_ws_id) {
      // 设备列表工地id
      // 如果设备号存在
      this.ws_id = this.record.d_ws_id;
      console.log("设备列表直接播放111");
      this.d_id = this.record.d_id;
      this.getVideo();
    }
    // console.log(this.ws_id);
    setTimeout(() => {
      this.wsModel = this.record.ws_model;
      this.type = this.record.ws_model;
      // 获取摄像头状态
      this.videoStatus("cycle");
    }, 1000);
    // 拉流;
    var videoElement = document.getElementById("myVideo");
    this.startPlay(this.stream_url + this.video.stream_id, videoElement);
    // // 推流
    this.startPublish(this.stream_url + this.video.push_stream_id, new Audio());
  },
  mounted() {
    // 进入页面默认静音
    this.handelPlay("jingyin");
    window.onunload = function (e) {
      window.clearTimeout(this.timer); // 清理定时器
      this.offCall();
      this.stopVideo();
    };
    window.addEventListener("beforeunload", (e) => {
      e = e || window.event;
      if (e) {
        this.close();
      }
    });
    // 10秒后清除获取信号值的定时器
    setTimeout(() => {
      clearInterval(this.getvideoSignalTimer);
      this.getvideoSignalTimer = null;
    }, 10000);
    this.isShowBtns = sessionStorage.getItem("isShowBtns").split(",");
    // console.log(this.isShowBtns);

    // // 默认播放的第一个设备为蓝色字体
    // setTimeout(() => {
    //   let BGCblue = document.getElementsByClassName("deviseList_name");
    //   // BGCblue[0].style.color = "#1890ff";
    //   //被点击
    //   BGCblue[0].style.color = "#cfe7fa";
    //   BGCblue[0].style.background = "#1486e6";
    // }, 1000);
  },
  watch: {
    ws_id(newVal) {
      // console.log("ws_id", newVal);
    },
    // 当摄像头状态为2时开始获取信号值
    Video_Status(newStatus, oldStatus) {
      if (newStatus == 2) {
        // setTimeout(() => {
        //   this.getvideoSignal();
        // }, 1000);
        // debugger;
      }
    },
    //如果未查询到该摄像头信号强度  两秒查询一次信号值
    signalResData2(newV, oldV) {
      if (newV == "未查询到该摄像头信号强度") {
        //如果未查询到该摄像头信号强度  两秒查询一次信号值
        this.getvideoSignalTimer = setInterval(() => {
          this.getvideoSignal();
          // console.log("newV == '未查询到该摄像头信号强度'");
        }, 2000);
      } else if (newV != oldV) {
        // console.log(newV, oldV);
        // 清除定时器
        clearInterval(this.getvideoSignalTimer);
        this.getvideoSignalTimer = null;
      }
    },
    // 监听设备号改变
    d_id(newVal, oldVal) {},
  },
  methods: {
    // 查询工地绑定设备信息
    GetWsbinddevices() {
      const param = {
        ws_id: this.ws_id,
      };
      const orderParam = ["ws_id"];
      const requestParameters = this.$order(param, orderParam);
      const params = {
        ...requestParameters,
        verify: this.$verify(requestParameters, orderParam),
      };
      return GetWsbinddevices(params).then((res) => {
        this.ws_bind_d_ids = res.data;
        console.log("res.data", this.ws_bind_d_ids);
        this.index1 = 0;
        this.ws_bind_d_ids.forEach((el, index) => {
          if (el.ddefault == 1) {
            this.d_id = el.did;
            this.getVideo();
            // 默认播放设备为蓝色字体
            setTimeout(() => {
              let BGCblue = document.getElementsByClassName("deviseList_name");
              // BGCblue[0].style.color = "#1890ff";
              //被点击
              BGCblue[index].style.color = "#cfe7fa";
              BGCblue[index].style.background = "#1486e6";
            }, 1000);
          } else {
            this.index1++;
            console.log("  this.index1+", this.index1);
            if (this.index1 == this.ws_bind_d_ids.length) {
              this.d_id = this.ws_bind_d_ids[0].did;
              this.getVideo();
              setTimeout(() => {
                let BGCblue =
                  document.getElementsByClassName("deviseList_name");
                // BGCblue[0].style.color = "#1890ff";
                //被点击
                BGCblue[0].style.color = "#cfe7fa";
                BGCblue[0].style.background = "#1486e6";
              }, 1000);
            }
          }
        });
      });
    },

    // 查询视频推流、拉流地址
    getVideo() {
      const params = {
        ws_id: this.ws_id,
        d_id: this.d_id,
        // ws_id: this.record.d_ws_id,
      };
      GetSiteVideo(params).then((res) => {
        if (res.code == 200) {
          // this.video.com_only=res.data.com_only
          this.posterImg = this.pathUrl + res.data.file_path;
          this.video = res.data;
          const url = res.data.video_url;
          const push_url = res.data.audio_url;
          this.video.stream_id = url.substring(url.lastIndexOf("/") + 1);
          this.video.push_stream_id = push_url.substring(
            push_url.lastIndexOf("/") + 1
          );
          // 拉流
          this.videoPlayer();
          // 推流
          // this.talkStartTest();
          this.startPublish(
            this.stream_url + this.video.push_stream_id,
            new Audio()
          );

          // // 获取摄像头状态
          // this.videoStatus("cycle");
        } else {
          // this.$message.error(res.data);
          if (res.data == "摄像头状态为：4") {
            this.$message.error("自动挂断");
          }
        }
      });
    },

    // 每隔1秒检测一次摄像头状态
    checkStatus() {
      let that = this;
      if (that.cycleTime < that.cycleMax) {
        that.timer = setTimeout(() => {
          that.videoStatus("cycle");
          that.cycleTime++;
        }, 1000);
      } else {
        that.$message.warn("直播查看超时");
        this.stopVideo();
      }
    },
    // 检测视频流状态
    videoStatus(type) {
      const params = {
        ws_id: this.ws_id,
        d_id: this.d_id,
        com_only: this.video.com_only,
      };
      CameraStatus(params).then((res) => {
        this.Video_Status = res.data;
        // console.log("检测摄像头状态", this.Video_Status);
        if (res.data === "2") {
          window.clearTimeout(this.timer); // 清理定时器
          // 获取信号值
          setTimeout(() => {
            this.getvideoSignal();
          }, 1000);
          // 拉流
          // this.videoPlayer();
          //开始推流
          // this.talkStartTest();
          // console.log('this.video.push_stream_id', this.video.push_stream_id)
          // this.startPublish(
          //   this.stream_url + this.video.push_stream_id,
          //   new Audio()
          // );
        } else {
          if (type !== "cycle") {
            this.$message.error("视频加载中");
          } else {
            this.checkStatus();
          }
        }
      });
    },
    // flv拉流播放视频
    videoPlayer() {
      var videoElement = document.getElementById("myVideo");
      this.startPlay(this.stream_url + this.video.stream_id, videoElement);
      // if (flvjs.isSupported()) {
      if (false) {
        var videoElement = document.getElementById("myVideo");
        this.flvPlayer = flvjs.createPlayer({
          type: "flv",
          // url: 'https://dsm.wisecommey.com:8843/live?app=stream&stream=' + this.video.stream_id,
          url:
            // "https://dsm.wisecommey.com:8843/stream/" +
            "https://dsm.ccom.com.cn:8843/stream/" +
            this.video.stream_id +
            ".flv",
          // url: 'http://123.56.117.58:8080/live/123456',
        });
        this.flvPlayer.attachMediaElement(videoElement); //将播放实例注册到video节点
        this.flvPlayer.load();
        this.flvPlayer.play();
        this.flvPlayer.on(
          flvjs.Events.ERROR,
          (errorType, errorDetail, errorInfo) => {
            console.log("errorType:", errorType);
            console.log("errorDetail:", errorDetail);
            console.log("errorInfo:", errorInfo);
          }
        );
        this.flvPlayer.on(flvjs.Events.STATISTICS_INFO, function (info) {
          console.log(
            "STATISTICS_INFO:",
            info,
            videoElement.currentTime,
            videoElement.readyState
          );
          if (info.speed !== 0) {
            if (this.decodedFrames === info.decodedFrames) {
              this.count++;
            } else {
              this.count = 0;
            }
            if (this.count == 5) {
              console.log("卡住了", videoElement.currentTime);
              videoElement.currentTime = videoElement.buffered.end(0) - 0.2;
            }
            this.decodedFrames = info.decodedFrames;
          }
        });

        this.timeout = setInterval(() => {
          if (videoElement.buffered.length) {
            let end = videoElement.buffered.end(0);
            let diff = end - videoElement.currentTime;
            console.log("diff:", diff);
            if (diff >= 4.0) {
              videoElement.currentTime = videoElement.buffered.end(0) - 0.2;
              console.log("跳帧");
            } else if (diff >= 2.0) {
              if (videoElement.playbackRate === 1.0) {
                videoElement.playbackRate = 1.5; // 采用加速方式追帧
                console.log("追帧(1.5倍速)");
              }
            } else {
              if (videoElement.playbackRate !== 1.0) {
                videoElement.playbackRate = 1.0;
                console.log("1.0速度");
              }
            }
          }
        }, 2000);
      }
    },
    startPlay(url, video) {
      this.player = new SrsRtcPlayerAsync(video);
      // https://webrtc.org/getting-started/remote-streams
      // Optional callback, SDK will add track to stream.
      // sdk.ontrack = function (event) { console.log('Got track', event); sdk.stream.addTrack(event.track); };
      // For example: webrtc://r.ossrs.net/live/livestream
      this.player
        .play(url)
        .then(function (session) {
          // console.log("sessionid", session.simulator, session.sessionid);
        })
        .catch(function (reason) {
          this.player.close();
          console.error(reason);
        })
        .finally(() => {});
      // console.log(this.player);
    },
    // 关闭
    close() {
      window.clearTimeout(this.timer); // 清理定时器
      this.offCall();
      this.stopVideo();
    },
    // 推流
    //方法未使用
    pushVideo() {
      window.navigator.webkitGetUserMedia(); //调用本地摄像头麦克风
    },
    stopVideo() {
      const params = {
        ws_id: this.ws_id,
        d_id: this.d_id,
        com_only: this.video.com_only,
      };
      // this.talkEndTest(); //断开通话
      if (this.publisher) {
        this.publisher.close();
      }
      if (this.flvPlayer) {
        clearInterval(this.timeout);
        this.flvPlayer.unload(); //取消数据流加载
        this.flvPlayer.detachMediaElement(); //将播放实例从节点中取出
        this.flvPlayer.destroy(); //销毁播放实例
        this.flvPlayer = null;
      }
      StopSiteVideo(params)
        .then((res) => {
          // this.$message.success("断开视频成功");
        })
        .catch(() => {
          // this.$message.error("断开视频失败");
        });
    },
    handleCall() {
      this.voiceCall = !this.voiceCall;
      if (this.voiceCall) {
        this.onCall();
      } else {
        this.offCall();
      }
    },
    // 通话
    onCall() {
      const params = {
        ws_id: this.ws_id,
        d_id: this.d_id,
        com_only: this.video.com_only,
      };
      OnCall(params).then((res) => {
        console.log(res);
        if (res.code == "200" && res.data == "通话链接成功") {
          var videoElement = document.getElementById("myVideo");
          // videoElement.muted = true;
          this.voiceCall = true;
          this.$message.success("通话中");
        } else {
          this.$message.success("通话忙");
        }
      });
    },
    // 通话结束
    offCall() {
      const params = {
        ws_id: this.ws_id,
        d_id: this.d_id,
        com_only: this.video.com_only,
      };
      OffCall(params).then((res) => {
        var videoElement = document.getElementById("myVideo");
        // videoElement.muted = false;
        this.voiceCall = false;
        // this.$message.success("通话结束");
      });
    },
    // 移动摄像机位置
    moveCamera(direction, directionCH) {
      const params = {
        ws_id: this.ws_id,
        d_id: this.d_id,
        com_only: this.video.com_only,
        direction: direction,
      };
      CameraMove(params).then((res) => {
        // this.$message.success("向" + directionCH + res.data);
      });
    },
    // 返回预置位
    reset() {
      // console.log(document.getElementById("myVideo").currentTime); //  获取当前播放时间
      // let ImgLoading = document.getElementById("ImgLoading");
      // ImgLoading.style.display = "block";
      const params = {
        ws_id: this.ws_id,
        d_id: this.d_id,
        com_only: this.video.com_only,
      };
      CameraReset(params).then((res) => {
        // this.$message.success(res.data);
        if (res.data == "摄像头复位设置成功") {
          this.$message.success("返回预置位成功");
        }
        // var myVideo = document.getElementById("myVideo");
        // var eventTester = (e) => {
        //   myVideo.addEventListener(e, (e) => {
        //     console.log("555");
        //   });
        // };
        // console.log(document.getElementById("myVideo").currentTime); //  获取当前播放时间
        // document.getElementById("myVideo").load();
        // eventTester("waiting"); //等待数据，并非错误
        // eventTester("seeking"); //寻找中
        // eventTester("canplay"); //可以播放，但中途可能因为加载而暂停
        // eventTester("timeupdate"); //播放时间改变
        // eventTester("error"); //请求数据时遇到错误  没用
        // eventTester("play"); //play()和autoplay开始播放时触发
        // eventTester("playing"); // playing：当视频在已因缓冲而暂停或停止后已就绪时触发
        // eventTester("pause"); //监听暂停
      });
    },
    handleRestart() {
      this.visible = true;
    },
    restartCancel() {
      this.visible = false;
    },
    // 重启摄像头
    restart() {
      this.confirmLoading = true;
      const params = {
        ws_id: this.ws_id,
        d_id: this.d_id,
        com_only: this.video.com_only,
      };
      CameraRestart(params)
        .then((res) => {
          this.$message.success("重启摄像头成功");
          this.confirmLoading = false;
          this.visible = false;
        })
        .catch(() => {
          this.$message.error("重启摄像头失败");
          this.confirmLoading = false;
        });
    },
    onPlayerPlay() {},
    onPlayerPause() {},
    //屏幕截图
    screenshot() {
      var canvas = document.getElementById("screenshot");
      if (!canvas.getContext) {
        alert("您的浏览器暂不支持canvas");
        return false;
      } else {
        var context = canvas.getContext("2d");
        var video = document.getElementById("myVideo");
        context.drawImage(video, 0, 0, canvas.width, canvas.height);
        var mySrc = canvas.toDataURL("image/png");
      }
      var alink = document.createElement("a");
      alink.href = mySrc;
      alink.download = "jietu.png"; //图片名
      alink.click();
    },

    //对讲-语音推流
    init(rec) {
      this.soundrecord = rec;
    },
    talkStartTest1() {
      let that = this;
      navigator.getUserMedia =
        navigator.getUserMedia || navigator.webkitGetUserMedia;
      if (!navigator.getUserMedia) {
        alert("浏览器不支持音频输入");
      } else {
        navigator.getUserMedia(
          {
            audio: true,
          },
          function (mediaStream) {
            that.init(new that.Recorder(mediaStream, that));
            console.log("开始对讲");
            that.useWebSocket();
          },
          function (error) {
            console.log(error);
            switch (error.message || error.name) {
              case "PERMISSION_DENIED":
              case "PermissionDeniedError":
                console.info("用户拒绝提供信息。");
                break;
              case "NOT_SUPPORTED_ERROR":
              case "NotSupportedError":
                console.info("浏览器不支持硬件设备。");
                break;
              case "MANDATORY_UNSATISFIED_ERROR":
              case "MandatoryUnsatisfiedError":
                console.info("无法发现指定的硬件设备。");
                break;
              default:
                console.info(
                  "无法打开麦克风。异常信息:" + (error.code || error.name)
                );
                break;
            }
          }
        );
      }
    },
    // 新版使用方法
    talkStartTest() {
      // 老的浏览器可能根本没有实现 mediaDevices，所以我们可以先设置一个空的对象
      if (navigator.mediaDevices === undefined) {
        navigator.mediaDevices = {};
      }
      // 一些浏览器部分支持 mediaDevices。我们不能直接给对象设置 getUserMedia
      // 因为这样可能会覆盖已有的属性。这里我们只会在没有getUserMedia属性的时候添加它。
      if (navigator.mediaDevices.getUserMedia === undefined) {
        navigator.mediaDevices.getUserMedia = function (constraints) {
          // 首先，如果有getUserMedia的话，就获得它
          var getUserMedia =
            navigator.webkitGetUserMedia || navigator.mozGetUserMedia;

          // 一些浏览器根本没实现它 - 那么就返回一个error到promise的reject来保持一个统一的接口
          if (!getUserMedia) {
            return Promise.reject(new Error("浏览器不支持getUserMedia"));
          }

          // 否则，为老的navigator.getUserMedia方法包裹一个Promise
          return new Promise(function (resolve, reject) {
            getUserMedia.call(navigator, constraints, resolve, reject);
          });
        };
      }

      let that = this;
      navigator.mediaDevices
        .getUserMedia({ audio: true, video: false })
        .then(function (stream) {
          that.init(new that.Recorder(stream, that));
          console.log("开始对讲");
          that.useWebSocket();
        })
        .catch(function (err) {
          // console.log(err.name + ": " + err.message);
        });
    },
    // 关闭对讲
    talkEndTest() {
      if (this.ws) {
        this.ws.close();
        this.soundrecord.stop();
        console.log("关闭对讲以及WebSocket");
      }
    },
    // 推流
    startPublish(url, audio) {
      this.publisher = new SrsRtcPublisherAsync(audio);
      // console.log('startPublish', this.publisher)
      const publisher = this.publisher;
      this.publisher.pc.onicegatheringstatechange = function (event) {
        if (publisher.pc.iceGatheringState === "complete") {
          //  $('#acodecs').html(SrsRtcFormatSenders(sdk.pc.getSenders(), "audio"))
          //  $('#vcodecs').html(SrsRtcFormatSenders(sdk.pc.getSenders(), "video"))
        }
      };
      this.publisher
        .publish(url)
        .then(function (session) {
          console.log("sessionid", session.simulator, session.sessionid);
          publisher.mute();
        })
        .catch(function (reason) {
          // Throw by sdk.
          if (reason instanceof SrsError) {
            if (reason.name === "HttpsRequiredError") {
              alert(
                `WebRTC推流必须是HTTPS或者localhost：${reason.name} ${reason.message}`
              );
            } else {
              alert(`${reason.name} ${reason.message}`);
            }
          }
          // See https://developer.mozilla.org/en-US/docs/Web/API/MediaDevices/getUserMedia#exceptions
          if (reason instanceof DOMException) {
            if (reason.name === "NotFoundError") {
              // alert(
              //   `找不到麦克风和摄像头设备：getUserMedia ${reason.name} ${reason.message}`
              // );
            } else if (reason.name === "NotAllowedError") {
              alert(
                `你禁止了网页访问摄像头和麦克风：getUserMedia ${reason.name} ${reason.message}`
              );
            } else if (
              [
                "AbortError",
                "NotAllowedError",
                "NotFoundError",
                "NotReadableError",
                "OverconstrainedError",
                "SecurityError",
                "TypeError",
              ].includes(reason.name)
            ) {
              alert(`getUserMedia ${reason.name} ${reason.message}`);
            }
          }
          publisher.close();
          // console.error(reason);
        });
    },
    Recorder(stream, that) {
      var sampleBits = 16; //输出采样数位 8, 16
      var sampleRate = 16000; //输出采样率
      var context = new AudioContext();
      var audioInput = context.createMediaStreamSource(stream);
      var recorder = context.createScriptProcessor(4096, 1, 1);
      var audioData = {
        size: 0, //录音文件长度
        buffer: [], //录音缓存
        inputSampleRate: 48000, //输入采样率
        inputSampleBits: 16, //输入采样数位 8, 16
        outputSampleRate: sampleRate, //输出采样数位
        oututSampleBits: sampleBits, //输出采样率
        clear: function () {
          this.buffer = [];
          this.size = 0;
        },
        input: function (data) {
          this.buffer.push(new Float32Array(data));
          this.size += data.length;
        },
        compress: function () {
          //合并压缩
          //合并
          var data = new Float32Array(this.size);
          var offset = 0;
          for (var i = 0; i < this.buffer.length; i++) {
            data.set(this.buffer[i], offset);
            offset += this.buffer[i].length;
          }
          //压缩
          var compression = parseInt(
            this.inputSampleRate / this.outputSampleRate
          );
          var length = data.length / compression;
          var result = new Float32Array(length);
          var index = 0,
            j = 0;
          while (index < length) {
            result[index] = data[j];
            j += compression;
            index++;
          }
          return result;
        },
        encodePCM: function () {
          //这里不对采集到的数据进行其他格式处理，如有需要均交给服务器端处理。
          var sampleRate = Math.min(
            this.inputSampleRate,
            this.outputSampleRate
          );
          var sampleBits = Math.min(this.inputSampleBits, this.oututSampleBits);
          var bytes = this.compress();
          var dataLength = bytes.length * (sampleBits / 8);
          var buffer = new ArrayBuffer(dataLength);
          var data = new DataView(buffer);
          var offset = 0;
          for (var i = 0; i < bytes.length; i++, offset += 2) {
            var s = Math.max(-1, Math.min(1, bytes[i]));
            data.setInt16(offset, s < 0 ? s * 0x8000 : s * 0x7fff, true);
          }
          return new Blob([data]);
        },
      };

      var sendData = function () {
        //对以获取的数据进行处理(分包)
        var reader = new FileReader();
        reader.onload = (e) => {
          var outbuffer = e.target.result;
          var arr = new Int8Array(outbuffer);
          if (arr.length > 0) {
            var tmparr = new Int8Array(1024);
            var j = 0;
            for (var i = 0; i < arr.byteLength; i++) {
              tmparr[j++] = arr[i];
              if ((i + 1) % 1024 == 0) {
                if (that.ws.readyState == 1) {
                  console.log(tmparr);
                  that.ws.send(tmparr);
                }
                if (arr.byteLength - i - 1 >= 1024) {
                  tmparr = new Int8Array(1024);
                } else {
                  tmparr = new Int8Array(arr.byteLength - i - 1);
                }
                j = 0;
              }
              if (i + 1 == arr.byteLength && (i + 1) % 1024 != 0) {
                if (that.ws.readyState == 1) {
                  that.ws.send(tmparr);
                }
              }
            }
          }
        };
        reader.readAsArrayBuffer(audioData.encodePCM());
        audioData.clear(); //每次发送完成则清理掉旧数据
      };

      this.start = function () {
        audioInput.connect(recorder);
        recorder.connect(context.destination);
      };

      this.stop = function () {
        recorder.disconnect();
      };

      this.getBlob = function () {
        return audioData.encodePCM();
      };

      this.clear = function () {
        audioData.clear();
      };

      recorder.onaudioprocess = function (e) {
        var inputBuffer = e.inputBuffer.getChannelData(0);
        audioData.input(inputBuffer);
        sendData();
      };
    },
    useWebSocket() {
      let that = this;
      this.ws = new WebSocket(
        // "wss://dsm.wisecommey.com:8443/ws/asset/" + that.video.push_stream_id
        "wss://dsm.ccom.com.cn:8443/ws/asset/" + that.video.push_stream_id
      );
      // this.ws = new WebSocket("wss://dsm.wisecommey.com:8443/ws/asset/123");
      this.ws.binaryType = "arraybuffer"; //传输的是 ArrayBuffer 类型的数据
      this.ws.onopen = function () {
        console.log("握手成功");
        console.log(that.ws);
        if (that.ws.readyState == 1) {
          //ws进入连接状态，则每隔500毫秒发送一包数据
          that.soundrecord.start();
        }
      };
      this.ws.onmessage = function (msg) {
        console.info(msg);
      };
      this.ws.onerror = function (err) {
        console.info(err);
      };
    },
    // 巡查页添加设置样板工地按钮
    setSampleSiteBTN() {
      if (this.wsModel == "0") {
        this.wsModel = this.record.ws_model; //ws_model==1是样板工地
        this.type = this.record.ws_model; //type==2设置为样板工地
      }
      if (this.wsModel == 1) {
        this.type = 1;
        this.wsModel = 2;
      } else if (this.wsModel == 2) {
        this.type = 2;
        this.wsModel = 1;
      }

      const params = {
        ws_ids: this.ws_id, //分公司id
        // ws_model: type,
        ws_model: this.type,
      };
      // console.log("this.record.ws_model==" + this.record.ws_model);
      // console.log("this.wsModel==" + this.wsModel);
      // console.log("this.type==" + this.type);
      // console.log(params);
      SetSampleSite(params).then((res) => {
        // console.log(res);
        var back = res.data;
        if (back === "设置成功") {
          if (this.type == 2) {
            this.$message.success("设置样板工地成功");
          } else if (this.type == 1) {
            this.$message.success("取消样板工地成功");
          }
          // this.$message.success(back);
        } else {
          this.$message.error(back);
        }
      });
      // this.$router.go(0);
    },
    quxiaoSampleSiteBTN() {
      // console.log(66666);
      if (this.typecaseField == 1) {
        this.typecaseField = 2; //2的时候为取消样板工地
        this.ModelcaseField = 2;
      } else if (this.typecaseField == 2) {
        this.typecaseField = 1;
        this.ModelcaseField = 1;
      }
      const params = {
        ws_ids: this.ws_id, //分公司id
        ws_model: this.ModelcaseField,
      };
      SetSampleSite(params).then((res) => {
        // console.log(res);
        var back = res.data;
        if (back === "设置成功") {
          if (this.typecaseField == 1) {
            this.$message.success("取消样板工地成功");
          } else if (this.typecaseField == 2) {
            this.$message.success("设置样板工地成功");
          }

          // this.$message.success(back);
        } else {
          this.$message.error(back);
        }
      });
    },
    // 暂停播放按钮
    bofangPlay(type) {
      let bofang = document.getElementById("myVideo");

      if (type == "bofang") {
        bofang.play();
        this.bofang = 2;
      } else if (type == "zanting") {
        bofang.pause();
        console.log("暂停");
        this.bofang = 1;
      }
    },
    // 静音/取消静音按钮
    handelPlay(type) {
      // this.$refs.videoPlayer.play(); // 会触发videoPlay()函数
      let jingyin = document.getElementById("myVideo");
      if (type == "jingyin") {
        jingyin.muted = true;
        this.jingyin = 2;
        // console.log("静音");
      } else if (type == "quxiaojingyin") {
        jingyin.muted = false;
        this.jingyin = 1;
        // console.log("取消静音");
      }
    },
    // 全屏
    quanping() {
      let quanping = document.getElementById("myVideo");
      quanping.webkitRequestFullScreen();
    },
    // 信号展示
    getvideoSignal() {
      const params = {
        ws_id: this.ws_id,
        d_id: this.d_id,
        type: "1",
      };
      videoSignal(params).then((res) => {
        // console.log("type==1");
        if (res.data == "摄像机没有上线") {
          this.NoXinhao = true;
          this.setSign("0");
        }
        if (res.data == "向摄像头发送请求成功") {
          const params2 = {
            ws_id: this.ws_id,
            d_id: this.d_id,
            type: "2",
          };
          videoSignal(params2).then((res) => {
            // console.log(res);
            this.signalResData2 = res.data;
            // console.log(
            //   "type==2",
            //   this.signalResData2,
            //   this.signalResData2 * 1
            // );
            if (res.data == "未查询到该摄像头信号强度") {
              this.NoXinhao = true;
              this.setSign("0");
              // var tmpElement = document.getElementById("div_sign");
              // tmpElement.style.display = "none";
            } else {
              this.NoXinhao = false;
              this.getdbm(res.data);
              // var tmpElement = document.getElementById("div_sign");
              // tmpElement.style.display = "block";
              // console.log(res.data);
            }
          });
        }
      });
    },
    // 获取信号质量数值
    getdbm(dbm) {
      let count = "";
      if (dbm > -50) {
        count = 5;
      } else if (dbm > -90) {
        count = 4;
      } else if (dbm > -100) {
        count = 3;
      } else if (dbm > -110) {
        count = 2;
      } else if (dbm > -120) {
        count = 1;
      } else if (dbm < -120) {
        count = 0;
        this.NoXinhao = true;
      }
      // console.log(count);
      this.setSign(count);
    },
    setSign(count) {
      var tmpElement = document.getElementById("div_sign");
      for (var i = 0; i < 5; i++) {
        tmpElement.children[i].style.backgroundColor = "#FFF";
        if (i <= count - 1) {
          if (count < 2) {
            tmpElement.children[i].style.backgroundColor = "red"; //一格时为红色
          } else {
            tmpElement.children[i].style.backgroundColor = "#00FF00";
          }
        }
      }
    },
    SiteHistoryRecordBTN() {
      this.visibleHistory = true;
      this.recordwsid = this.ws_id;
      // console.log(recordwsid);
      // console.log(this.ws_id);
    },
    showModalHistory() {
      this.visibleHistory = true;
    },
    handleOkHistory(e) {
      this.ModalText = "The modal will be closed after two seconds";
      this.confirmLoadingHistory = true;

      this.visibleHistory = false;
      this.confirmLoadingHistory = false;
    },
    handleCancelHistory(e) {
      console.log("Clicked cancel button");
      this.visibleHistory = false;
    },
    // 设置摄像头初始位置
    returnCameraPreset() {
      let params = {
        ws_id: this.ws_id,
        d_id: this.d_id,
        com_only: this.video.com_only,
      };
      getSitPreset(params).then((res) => {
        // console.log(res);
        if (res.data == "摄像头初始位置设置成功") {
          this.$message.success("保存预置位成功");
        }
        console.log(
          "videoElement..readyState",
          document.getElementById("myVideo").readyState
        );
      });
    },
    // 查看回放
    playbackBTN() {
      // console.log(this.record);

      this.$emit("JumpSubpage", this.record, "SitePlayback", "回放");
      this.$emit("onClose");
    },
    // 改变设备号
    changed_id(e, index) {
      console.log("改变设备号", e);
      // 先关闭为改变设备号之前的直播
      this.close();
      // 清除之前的信号状态获取
      clearInterval(this.getvideoSignalTimer);
      this.getvideoSignalTimer = null;
      // 再改变设备号
      this.d_id = e;
      // 开始拉流
      this.getVideo();
      // 获取信号状态
      this.getvideoSignalTimer = setInterval(() => {
        // this.getvideoSignal();
      }, 2000);
      // 获取摄像头状态
      setTimeout(() => {
        this.videoStatus("cycle");
      }, 2000);
      // 点击的设备改变为蓝色字体
      for (let index1 = 0; index1 < this.ws_bind_d_ids.length; index1++) {
        console.log("222");
        let BGCblue = document.getElementsByClassName("deviseList_name");
        if (index1 != index) {
          // BGCblue[index1].style.color = "#000";
          BGCblue[index1].style.background = "#cfe7fa";
          BGCblue[index1].style.color = "#1486e6";
        } else {
          // BGCblue[index].style.color = "#1890ff";
          //被点击
          BGCblue[index1].style.color = "#cfe7fa";
          BGCblue[index1].style.background = "#1486e6";
        }
      }
    },
    // 设置默认设备
    Setdefault() {
      const param = {
        d_id: this.d_id,
      };
      const orderParam = ["d_id"];
      const requestParameters = this.$order(param, orderParam);
      const params = {
        ...requestParameters,
        verify: this.$verify(requestParameters, orderParam),
      };
      return Setdefault(params).then((res) => {
        console.log(res);
        if (res.code == "200") {
          this.$message.success(res.data);
        } else {
          this.$message.error(res.data);
        }
      });
    },
  },
  beforeDestroy() {
    // window.location.reload();
    if (this.player) {
      this.player.close();
    }
    if (this.publisher) {
      this.publisher.close();
    }
    this.close();
    // this.talkEndTest();
    clearInterval(this.getvideoSignalTimer);
    this.getvideoSignalTimer = null;
  },
};
</script>

<style lang="less" scoped>
//所有控件
// video::-webkit-media-controls-enclosure {
//   display: block;
// }
// video::-webkit-media-controls-timeline {
//   display: block;
// }
/*controls进度条一直显示*/
// .vjs-has-started.vjs-user-inactive.vjs-playing .vjs-control-bar {
//   opacity: 1;
// }
// .vjs-has-started.vjs-user-inactive.vjs-playing .vjs-control-bar {
//   opacity: 1;
// }
// // 播放按钮
video::-webkit-media-controls-play-button {
  display: none !important;
}
// 当前播放时间
// video::-webkit-media-controls-current-time-display {
//   display: none !important;
// }
// 剩余时间
// video::-webkit-media-controls-time-remaining-display {
//   display: none !important;
// }
// 音量按钮
// video::-webkit-media-controls-volume-control-container {
//   display: none !important;
// }
// 全屏
video::-webkit-media-controls-fullscreen-button {
  display: none !important;
}
// 时间轴
video::-webkit-media-controls-timeline {
  display: none !important;
}
.bm-view {
  width: 100%;
  height: 200px;
}
.opt-button {
  position: absolute;
  bottom: 80px;
  // background-color: pink;
  width: 85%;
  // margin-left: 150px;
  margin-left: 90px;
  margin-top: 40px;
  button {
    margin-top: 5px;
    margin-right: 5px;
    i {
      padding-right: 5px;
    }
  }
}

.direction-button {
  border: solid 1px black;
  border-radius: 50%;
  width: 87px;
  // margin-left: 20px;
  margin-left: -10px;
  margin-top: 20px;
  // background-color: pink;
  .ant-col {
    height: 25px;
  }
  .dir-btn {
    cursor: pointer;
  }
  .ant-row {
    // padding-left: 5px;
    padding-left: 9px;
  }
}
.divScreenshot {
  display: none;
}

.xinhaoRed {
  color: red;
  font-size: 12px;
  margin: 0;
  padding: 0;
  margin-bottom: -25px;
}
@media screen and(min-width: 1400px) {
  .xinhaoRed {
    margin-bottom: -10px;
  }
}
.opt-button2 {
  .xinhao {
    // bottom: 10px;
    width: 30px;
    background-color: pink;
    // height: 30px;
    top: 100px;
    // margin-top: -560px;
    // left: 550px;
    margin-top: -75%;
    left: 90%;
    position: absolute;
  }
}

// .opt-button-xuncha {
//   .xinhao {
//     // bottom: 10px;
//     width: 30px;
//     // background-color: pink;
//     // height: 30px;
//     top: 100px;
//     margin-top: -560px;
//     left: 550px;
//     position: absolute;
//   }
// }
// 巡查页直播信号样式
.opt-button-xuncha {
  display: flex;
  justify-content: right;
  .xinhao {
    position: absolute;
    z-index: 99;
    left: 900px;
    top: -660px;
    height: 18px;
    display: flex;
    // background-color: pink;
  }

  .xinhaoRed {
    font-size: 12px;
    margin: 0;
    padding: 0;
    margin-top: -5px;
    margin-right: -10px;
    width: 10px;
    height: 10px;
  }
  // background-color: red;
  // width: 80%;
  // bottom: 100px;
}
.dir-patrol {
  position: absolute;
  // top: -200px;
  top: -60px;
  // left: 20px;
  left: -40px;
  height: 100px;
  width: 100px;
  border-radius: 50%;
  background-color: rgba(0, 0, 0, 0.5);
  color: #fff;
  padding-top: 10px;
  border: 1px solid #aaa;
  .ant-col {
    height: 30px;
  }
  .dir-btn {
    cursor: pointer;
  }
}
.v-btn-out {
  background: none !important;
}
@media screen and(min-width: 1600px) {
  .opt_button2 {
    // background-color: red;
    // bottom: 320px;
    top: 580px;
    height: 30px;
    // width: 75%;
    width: 84%;
    .xinhao {
      // background-color: red;
      // bottom: 10px;
      width: 30px;
      // height: 30px;
      // top: 100px;
      top: 106px;
      // margin-top: -93%;
      margin-top: -82%;
      // left: 560px;
      left: 91%;
      position: absolute;
    }
  }
  // 巡查页直播信号样式
  .xuncha_xinhao {
    .xinhao {
      position: absolute;
      z-index: 99;
      left: 100%;
      top: -590px;
      height: 18px;
      display: flex;
      // background-color: red;
    }

    .xinhaoRed {
      margin-top: -5px;
      font-size: 8px;
      margin-right: -11px;
    }
  }
}
@media screen and(max-width: 1600px) {
  .opt_button2 {
    // background-color: pink;
    // bottom: 320px;
    // top: 540px;
    top: 559px;
    // top: 56%;
    height: 30px;
    .xinhao {
      // bottom: 10px;
      width: 30px;
      // background-color: red;
      // height: 30px;
      // top: 100px;
      top: 106px;
      // margin-top: -85%;
      margin-top: -82%;
      // left: 560px;
      // left: 94%;
      left: 95%;
      position: absolute;
    }
  }
  // 巡查页直播信号样式
  .xuncha_xinhao {
    .xinhao {
      position: absolute;
      z-index: 99;
      left: 100%;
      // top: -660px;
      top: -590px;
      height: 18px;
      display: flex;
      // background-color: pink;
    }

    // .xinhaoRed {
    //   // color: red;
    //   // font-size: 20px;
    //   // margin-top: 5px;
    // }
  }
}
@media screen and(max-width: 1366px) {
  .opt_button2 {
    // background-color: #aaa;
    // bottom: 360px;
    // top: 530px;
    top: 543px;
    // top: 59%;
    .xinhao {
      // bottom: 10px;
      width: 30px;
      // background-color: rgb(206, 130, 130);
      // height: 30px;
      // top: 100px;
      top: 106px;
      // margin-top: -86%;
      margin-top: -81%;
      // left: 560px;
      left: 96%;
      position: absolute;
    }
  }
  // 巡查页直播信号样式
  .xuncha_xinhao {
    .xinhao {
      position: absolute;
      z-index: 99;
      // left: 80%;
      left: 100%;
      top: -660px;
      height: 18px;
      display: flex;
      // background-color: white;
    }

    // .xinhaoRed {
    //   // color: red;
    //   // font-size: 20px;
    //   // margin-top: 5px;
    // }
  }
}
.opt_button2 {
  display: flex;
  justify-content: right;
}
.iconSize {
  font-size: 18px;
}
.v-btn {
  margin-bottom: 10px;
  // width: 35px;
  font-size: 12px;
  // background-color: pink;
}
.HistoryRecord {
  color: #1486e6;
  margin-top: 40px;
  cursor: pointer;
  display: flex;
  .playback {
    margin-left: 20px;
  }
}
.setdefault {
  margin-left: 20px;
}
#ImgLoading {
  display: none;
}
.deviseList {
  display: flex;
  div {
    margin: 0 10px;
    cursor: pointer;
  }
  .deviseList_name {
    padding: 5px;
    border-radius: 5px;
    color: #1486e6;
    background-color: #cfe7fa;
  }
}
</style>
